<template>
  <div
    v-if="gettingHostCpu"
    class="p-4 analytics-loading"
  >
    <b-spinner variant="primary" />
  </div>
  <div v-else>
    <vue-apex-charts
      ref="cpuAnalytics"
      type="line"
      height="240"
      :options="options"
      :series="series"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'CpuChart',
  components: {
    VueApexCharts,
  },
  data() {
    return {
      id: null,
    }
  },
  computed: {
    maxVal() {
      const element = this.hostCpu.length > 0
        ? this.hostCpu.reduce((el, ele) => (el.value > ele.value ? el : ele))
        : 0
      return element.value * 3
    },
    gettingHostCpu() {
      return this.$store.state.observability.gettingHostCpu
    },
    hostCpu() {
      return this.$store.state.observability.hostCpu
    },
    cpuAnalytics() {
      return this.hostCpu
        ? this.hostCpu.map(val => this.getLineChartValue(val))
        : []
    },
    series() {
      return [
        {
          data: this.cpuAnalytics.map(el => el.count),
          name: 'Usage',
        },
      ]
    },
    options() {
      return {
        chart: {
          id: 'cc',
          zoom: { enabled: false },
          type: 'line',
          dropShadow: {
            enabled: true,
            top: 18,
            left: 2,
            blur: 5,
            opacity: 0.2,
          },
          offsetX: -10,
          group: 'social',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        stroke: {
          show: true,
          curve: 'smooth',
          width: 4,
        },
        legend: {
          show: false,
        },
        colors: ['#df87f2'],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            inverseColors: false,
            gradientToColors: ['#1d79f2'],
            shadeIntensity: 1,
            type: 'horizontal',
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100],
          },
        },
        markers: {
          size: 0,
          hover: {
            size: 5,
          },
        },
        xaxis: {
          labels: {
            offsetY: 5,
            style: {
              fontSize: '0.857rem',
            },
            axisBorder: {
              show: false,
            },
            tickPlacement: 'on',
          },
          tickAmount: 5,
          categories: this.cpuAnalytics.map(el => el.name),
        },
        yaxis: {
          labels: {
            minWidth: 40,
            style: {
              fontSize: '0.857rem',
            },
            formatter: val => `${val.toLocaleString()}%`,
          },
          min: 0,
          max: this.maxVal >= 100 ? 100 : this.maxVal,
          tickAmount: 5,
        },
        tooltip: {
          followCursor: false,
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
          },
        },
      }
    },
  },
  created() {
    this.id = this.$route.params.id
    this.$store.dispatch('observability/getHostCPU', this.id).catch(err => {
      console.log(err)
    })
  },
  methods: {
    getLineChartValue(el) {
      return {
        name: this.findName(el.timestamp),
        count: el.value,
      }
    },
    findName(name) {
      const d = new Date(name)
      return `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
    },
  },
}
</script>
<style lang="scss" scoped>
.analytics-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 240px;
}
</style>
